<mat-form-field class="ignite-password-field" [attr.id]="id" [hideRequiredMarker]="true" appearance="outline" [class.is-empty]="isEmpty()">
  @if (label !== '') {
    <mat-label floatLabel>{{ label }}</mat-label>
  }
  <input
    matInput
    [type]="inputType"
    [formControl]="frmCtrl"
    [placeholder]="placeholder"
    [required]="required"
    [readonly]="readonly"
    [maxlength]="MAXIMUM_PASSWORD_LENGTH"
    />

    @for (cm of errorMessages; track cm) {
      <mat-error class="ignite-custom-error">
        @if (frmCtrl.hasError(cm.key)) {
          <span>{{ cm.message }}</span>
        }
      </mat-error>
    }

    <div
      #eyeCtrl
      class="show-hide-password hide"
      tabindex="-1"
      (click)="toggleShow($event, inputType === 'password')"
      (focusout)="onFocusout()"
      >
      <i class="fal fa-eye"></i><i class="fal fa-eye-slash"></i>
    </div>
  </mat-form-field>

  @if (!noStrengthCheck) {
    <div #strengths class="password-strength-wrapper">
      <div class="strengths-title" i18n>Your password must contain:</div>
      <div class="strengths">
        <div class="password-strength">
          <span class="size-strength unchecked"
            ><span><i class="fas fa-check-circle"></i><i class="far fa-times-circle"></i></span> </span
            ><span>At least {{ MINIMUM_PASSWORD_LENGTH }} characters</span>
          </div>
          <div class="password-strength">
            <span class="lower-strength unchecked"
              ><span><i class="fas fa-check-circle"></i><i class="far fa-times-circle"></i></span> </span
              ><span>A lowercase letter</span>
            </div>
            <div class="password-strength">
              <span class="cap-strength unchecked"
                ><span><i class="fas fa-check-circle"></i><i class="far fa-times-circle"></i></span> </span
                ><span>An uppercase letter</span>
              </div>
              <div class="password-strength">
                <span class="number-strength unchecked"
                  ><span><i class="fas fa-check-circle"></i><i class="far fa-times-circle"></i></span> </span
                  ><span>A number</span>
                </div>
                <div class="password-strength">
                  <span class="schar-strength unchecked"
                    ><span><i class="fas fa-check-circle"></i><i class="far fa-times-circle"></i></span> </span
                    ><span
                    >A special character
                    <i
                      class="fal fa-question-circle spec-char-info"
                      ignitetooltip="{{ specCharsTip }}"
                      ></i
                    ></span>
                  </div>
                </div>
              </div>
            }
